package nl.volleyplanner.api.backend_jobs

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

interface JobParameters

// TODO: Better match with backend jobs module. Create a shared package for definitions?
enum class JobType(val typeId: String, val backendJobName: String?, val startingArg: String, val requiredArgs: Int) {
    NevoboSyncVereniging("nevobo-vereniging", "NevoboSyncVereniging", "nevobo", 2),
    NevoboSyncRecentMatches("nevobo-recent-matches", "NevoboSyncRecentMatches", "nevobo", 2),
    NevoboSync("nevobo-overig", null, "nevobo", 2),
    UpdateTasks("tasks", null, "tasks", 1),
    PlannerJob("planner", "PlannerJob", "planner", 2),
    MonitorThuisprogramma("monitor_thuisprogramma", null, "monitor_thuisprogramma", 2);

    companion object {
        private val byTypeId = entries.associateBy(JobType::typeId)
        fun fromTypeId(typeId: String) = byTypeId[typeId]
    }
}

@Serializable
data class JobLaunchRequest(
    val JobArguments: List<String>
)

@Serializable
data class JobLaunchResponse(
    val jobName: String,
    val taskName: String,
    val cloudExecutionName: String
)

enum class JobStatus {
    Pending,
    Scheduled,
    Running,
    Finished
}

enum class JobResult {
    Success,
    PartialSuccess,
    Failure
}

@Serializable
data class JobExecution(
    val backendJobExecution: BackendJobExecution?,
    val cloudJobExecution: CloudJobExecution?
) {
    val status = cloudJobExecution?.jobStatus ?: backendJobExecution!!.jobStatus
    val result = cloudJobExecution?.jobResult ?: backendJobExecution?.jobResult
    val createdAt = cloudJobExecution?.createTime ?: backendJobExecution!!.createdAt
    val updatedAt = cloudJobExecution?.updateDateTime ?: backendJobExecution!!.updatedAt
}

@Serializable
data class BackendJobExecution(
    val identifier: String,
    val jobStatus: JobStatus,
    val jobResult: JobResult?,
    val createdBy: String,
    val createdAt: LocalDateTime,
    val updatedAt: LocalDateTime,
    val details: String?
)

@Serializable
data class CloudJobExecution(
    val jobName: String,
    val taskName: String,
    val cloudExecutionName: String,
    val cloudUid: String,

    val createTime: LocalDateTime,
    val startTime: LocalDateTime?,
    val completionTime: LocalDateTime?,
    val updateDateTime: LocalDateTime,
    val deleteDateTime: LocalDateTime?,
    val expireDateTime: LocalDateTime?,

    val taskCount: Int,
    val runningCount: Int,
    val succeededCount: Int,
    val failedCount: Int,
    val cancelledCount: Int,
    val retriedCount: Int
) {
    val jobResult: JobResult? = when {
        isCompleted() && succeededCount == taskCount -> JobResult.Success
        isCompleted() && succeededCount > 0 -> JobResult.PartialSuccess
        isCompleted() && failedCount == taskCount -> JobResult.Failure
        else -> null
    }

    val jobStatus = when {
        completionTime != null && completionTime.year >= 2024 -> JobStatus.Finished
        runningCount > 0 -> JobStatus.Running
        runningCount == 0 -> JobStatus.Scheduled
        else -> JobStatus.Pending
    }
    // Helper functions as we might get dates in 1970
    fun isCompleted(): Boolean = (completionTime != null && completionTime.year >= 2024)
}